import { UniqueEntityID } from './UniqueEntityID';

export class BaseEntity {
    _id;

    _props;

    static create(props, id) {
        return new this(props, id);
    }

    constructor(props, id) {
        this._id = id === undefined ? new UniqueEntityID() : id;
        this._props = props;
    }

    get id() {
        return this._id;
    }
}
